import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saVonrRetainabilityChartConfig } from '../chartConfigs';

interface VonrRetainabilitySaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const VonrRetainabilitySaEcharts: React.FC<VonrRetainabilitySaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saVonrRetainabilityChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default VonrRetainabilitySaEcharts;
